import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const AVAILABLE_LEVITATE_FIELDS_QUERY_KEY = 'integrations-available-levitate-fields';

export function useGetAvailableLevitateFieldsQuery({
	integrationProvider,
	impersonationContext,
}: {
	integrationProvider: Api.IntegrationProvider;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IImportFieldConfig[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/availableFields/levitate`,
				}),
				'GET'
			);
		},
		queryKey: [AVAILABLE_LEVITATE_FIELDS_QUERY_KEY, integrationProvider, impersonationContext],
	});
}

export const invalidateAvailableLevitateFieldsQuery = ({
	impersonationContext,
}: {
	impersonationContext: Api.IImpersonationContext;
}) => reactQueryClient.invalidateQueries({ queryKey: [AVAILABLE_LEVITATE_FIELDS_QUERY_KEY, impersonationContext] });
